

import React, { useContext } from "react";

import { classNames } from "primereact/utils";
import CodesContext from "../Context/CodesContext";
import AppContext from "../Context/AppContext";
import { Skeleton } from "primereact/skeleton";
import { Button } from "primereact/button";

const CodeCard = ({ data }) => {

    const { loading, setEditModal, setDeleteModal, setExecuteModal, setCurrentData } = useContext(CodesContext)
    const { user } = useContext(AppContext)

    return (
        <div className={classNames("item-card col-6 xl:col-3 p-2", loading ? "opacity-50" : "", data ? "" : "fadein animation-duration-200")}>
            {data ? (
                <div className="item-card-inner shadow-2 border-round flex flex-column h-full" style={{ backgroundColor: "#" + data.background, color: "#" + data.foreground }} onClick={(e) => { e.stopPropagation(); setCurrentData(data); setExecuteModal(true); }}>
                    <div className="px-3 py-2 text-xl font-semibold flex align-items-center" style={{ backgroundColor: "rgba(0, 0, 0, 0.1)" }}>
                        <span className="flex-1">{data.name}</span>
                        <div className="flex gap-2">
                            {user.permissions.admin && <i className="pi pi-pencil icon-button font-bold" style={{color: "#" + data.foreground}} onClick={(e) => { e.stopPropagation(); setCurrentData(data); setEditModal(true); }}></i>}
                            {user.permissions.admin && <i className="pi pi-trash icon-button font-bold" style={{color: "#" + data.foreground}} onClick={(e) => { e.stopPropagation(); setCurrentData(data); setDeleteModal(true); }}></i>}
                        </div>
                    </div>
                    <div className="px-3 py-3">{data.description}</div>
                </div>
            ) : (
                <div className="item-card-inner shadow-2 border-round surface-card flex flex-column h-full">
                    <div className="px-3 py-2 text-xl font-semibold" style={{ backgroundColor: "rgba(0, 0, 0, 0.1)", height: "40px" }}>
                        <Skeleton width="100%" height="100%"></Skeleton>
                    </div>
                    <div className="px-3 py-3" style={{ height: "51px" }}>
                        <Skeleton width="100%" height="100%"></Skeleton>
                    </div>
                </div>
            )}
        </div>
    );
}

export default CodeCard;